import uniqid from "uniqid";

  const makesData = [
    {
      name: 'acura',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/acura.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'audi',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/audi.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'bmw',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/bmw.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'cadillac',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/cadillac.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'chevrolet',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/chevrolet.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'chrysler',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/chrysler.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'dodge',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/dodge.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'ferrari',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/ferrari.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'ford',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/ford.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'gmc',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/gmc.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'honda',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/honda.png',
      id: uniqid(),
      selected: false
    },  
    {
      name: 'hyundai',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/hyundai.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'jeep',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/jeep.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'kia',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/kia.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'lamborghini',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/lamborghini.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'lexus',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/lexus.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'mercedes',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/mercedes.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'nissan',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/nissan.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'porsche',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/porsche.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'subaru',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/subaru.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'tesla',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/tesla.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'toyota',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/toyota.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'volkswagen',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/volkswagen.png',
      id: uniqid(),
      selected: false
    },
    {
      name: 'volvo',
      image: 'https://raw.githubusercontent.com/cleve703/memory-card-game/gh-pages/img/volvo.png',
      id: uniqid(),
      selected: false
    },
  ]


export default makesData;
